import React from 'react';
import {connect} from 'react-redux';

import Logger, {LOG_LEVELS} from '../../../utils/logger';
import { SSelect } from "@avalara/skylab-sdk/react";
const log = new Logger('SINGLE_USER_SELECTOR', LOG_LEVELS.DEBUG);

export class SingleUserSelector extends React.Component {

    selectionChangeHandlerFactory(fieldName) {
        return (event) => {
            log.debug('selectionChangeHandlerFactory(%s): %s, ', fieldName, event);
            log.debug('selectionChangeHandlerFactory(%s): oldValue: %s, newValue: %s  ', fieldName, this.props[fieldName], event.target.checked, event.detail.item.value);
            let selection = {};
            selection[fieldName] = event.detail.item.value !== '' ? event.detail.item.value : undefined;
            this.props.selectionHandler(selection);
        }
    }

    getSingleUserOptions() {
        let optionsList = [{
            label: 'Select user',
            value: ''
        }];
        this.props.userList && this.props.userList.forEach((user, ind) => {
            optionsList.push({
                label: user.id,
                value: user.id,
                selected: this.props.selectedUserId === user.id? true: false
            });
        })
        return optionsList;
    }

    render() {
        log.debug('render(): ', this.props);
        return (
            <SSelect defaultValue={this.props.selectedUserId} 
                inputId="single-month-select"
                name="users"
                onS-select={this.selectionChangeHandlerFactory(this.props.fieldName).bind(this)}
                optionsList={this.getSingleUserOptions() || []}
                multiple={false}
                showSelectionCount={false}
                role="combobox"
                data-testid="single-user-selector"
            />
        )
    }
}


function mapStateToProps(state) {
    log.debug('mapStateToProps: ', state);
    return {
        languages: state.languages
    };
}


// Wrap the component to inject state into it
export default connect(mapStateToProps)(SingleUserSelector);